import React, { useEffect, useRef, useState, } from 'react';
import { Dimensions, FlatList, Image as Img, Modal, Platform, ScrollView, StyleSheet, Text, TouchableOpacity, View, } from 'react-native';
import { ColorTokens, FontFamilyTokens, FontSizeTokens, IconSizeTokens, IconTokens, } from '@voltmoney/schema';
import { Icon } from '../icon/Icon';
import { HeaderDefaultBase } from '../header/HeaderDefault.Base';
import { addCommasToNumber } from '../stack/utils';
import { Typography } from '../typography/Typography';
let elssExist = false;
let equityExist = false;
let debtExist = false;
let selectedArray = [];
let selectedMap = {};
let combindedData = [];
let filters = [];
let nonEligibleFilters = [];
let totalEligibleValue = 0;
let totalNonValue = 0;
const eligibleData = [
    {
        isin: 'INF179K01YV8',
        nav: 853.432,
        ltv: 0.45,
        totalValue: 64000,
        eligibleValue: 64000,
        nonEligibleValue: 0,
        creditLimit: 28800,
        schemeName: 'HDFC Top 100 Fund',
        schemeCode: '44T',
        ownershipType: null,
        folioNumber: '21044673',
        amcCode: 'H',
        amcName: 'HDFC Mutual Fund',
        rtaCode: 'CAMS',
        panType: null,
        email: 'luniyaarpit240199@gmail.com',
        mobile: null,
        freeUnits: 75.03,
        blockedUnits: 0,
        blockedSubReason: null,
        blockedReason: null,
    },
    {
        isin: 'INF760K01EL8',
        nav: 134.24,
        ltv: 0.45,
        totalValue: 39200,
        eligibleValue: 39200,
        nonEligibleValue: 0,
        creditLimit: 17600,
        schemeName: 'Canara Robeco Equity Tax Saver ',
        schemeCode: 'ETDGG',
        ownershipType: null,
        folioNumber: '19922546862',
        amcCode: '101',
        amcName: 'Canara Robeco Mutual Fund',
        rtaCode: 'KARVY',
        panType: null,
        email: 'luniyaarpit240199@gmail.com',
        mobile: null,
        freeUnits: 292.52,
        blockedUnits: 0,
        blockedSubReason: null,
        blockedReason: null,
    },
];
let mData = {
    eligibleAssetData: undefined,
    nonEligibleAssetData: undefined,
};
const AssetDetails = ({ dataa, flatData, onFitlerSet, isFromEligible, onChangeText, learnWhyAction, triggerAction, height, hideFilter, showFlex, showPledgedFundsText = true, isFromForeclosure = false, }) => {
    const [showBar, setShowBar] = useState(true);
    const [eligiblePressed, setEligiblePresed] = useState(true);
    const [showFilter, setShowFilter] = useState(false);
    const [flatlistData, setFlatListData] = useState(dataa);
    const [filterData, setFilterData] = useState([]);
    const [selectedList, setSelectedList] = useState(selectedArray);
    const [refresh, setRefresh] = useState(true);
    const inputRef = useRef(null);
    const [filterName, setFilterName] = useState('EQUITY');
    const [allSelected, setAllSelected] = useState(false);
    useEffect(() => {
        mData = dataa;
        setFlatListData(dataa.eligibleAssetData);
    }, []);
    useEffect(() => {
        if (flatData?.length !== 0) {
            setFlatListData(flatData);
        }
    }, [flatData]);
    const renderItem = ({ item }) => {
        return (React.createElement(View, { style: {
                flexDirection: 'row',
                justifyContent: 'space-between',
                paddingVertical: 12,
            } },
            React.createElement(View, null,
                React.createElement(View, { style: { marginBottom: 8, width: Dimensions.get('window').width < 576 ? 200 : 300 } },
                    React.createElement(Typography, { label: item.assetName, color: ColorTokens.Grey_Night, fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, numberOfLines: 2, lineHeight: 20, fontWeight: '500' })),
                React.createElement(View, null,
                    React.createElement(Typography, { label: `Value: ₹${addCommasToNumber(Math.floor(item.assetPledgedValue))}`, color: ColorTokens.Grey_Charcoal, fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.XS, lineHeight: 18, fontWeight: '400' }))),
            React.createElement(View, { style: { alignItems: 'flex-end' } },
                React.createElement(Typography, { label: `₹${addCommasToNumber(Math.floor(item.assetCurrentLimit))}`, color: ColorTokens.Secondary_100, fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.MD, numberOfLines: 2 }))));
    };
    const ChecklistItem = ({ item, onPress }) => {
        const [isChecked, setIsChecked] = useState(false);
        const handlePress = (item) => {
            console.warn('IN THIS ');
            setIsChecked(!isChecked);
            handleItemPress(item.isin);
        };
        return (React.createElement(View, { style: {
                paddingVertical: 16,
                paddingLeft: 10,
                paddingRight: 15,
                justifyContent: 'center',
            } },
            React.createElement(View, { style: {
                    flexDirection: 'row',
                    alignItems: 'flex-start',
                    alignContent: 'center',
                } },
                React.createElement(TouchableOpacity, { style: { paddingRight: 2, paddingLeft: 2 }, onPress: () => {
                        let data = selectedList;
                        console.warn('SEL data prior ', data);
                        const index = data.indexOf(item.isin);
                        if (index > -1) {
                            data.splice(index, 1);
                        }
                        else {
                            data.push(item.isin);
                        }
                        console.warn('SEL data ', data);
                        setSelectedList(data);
                        if (eligiblePressed) {
                            setFilterData(mData?.eligibleAssetData?.MUTUAL_FUND.filter((item) => item.fundType === filterName));
                        }
                        else {
                            setFilterData(mData?.nonEligibleAssetData?.MUTUAL_FUND.filter((item) => item.blockedReason === filterName));
                        }
                        // switch (filterName) {
                        // 	case 'EQUITY': {
                        // 		setFilterData(
                        // 			combindedData.filter(
                        // 				(item) => item.fundType === 'EQUITY',
                        // 			),
                        // 		);
                        // 		return;
                        // 	}
                        // 	case 'DEBT': {
                        // 		setFilterData(
                        // 			combindedData.filter(
                        // 				(item) => item.fundType === 'DEBT',
                        // 			),
                        // 		);
                        // 		return;
                        // 	}
                        // 	case 'ELSS': {
                        // 		setFilterData(
                        // 			combindedData.filter(
                        // 				(item) => item.fundType === 'ELSS',
                        // 			),
                        // 		);
                        // 		return;
                        // 	}
                        //}
                        // setFilterData(filterData);
                    } },
                    React.createElement(Icon, { name: selectedList.includes(item.isin)
                            ? IconTokens.CheckedSquare
                            : IconTokens.NotCheckedSquare, size: IconSizeTokens.XXL })),
                React.createElement(TouchableOpacity, { style: styles.itemContainer, onPress: () => {
                        handlePress(item);
                    } },
                    React.createElement(Text, { style: {
                            fontFamily: 'Inter',
                            fontSize: 16,
                            color: '#1D2939',
                        } }, item.schemeName)))));
    };
    const handleItemPress = (itemId) => {
        const updatedItems = filterData.map((item) => item.isin === itemId
            ? { ...item, checked: !item.checked }
            : item);
        console.warn('UPDATED ITEMS', updatedItems);
        setFilterData(updatedItems);
    };
    const filterHeader = () => {
        return (React.createElement(View, null,
            React.createElement(View, { style: {
                    flexDirection: 'row',
                    alignItems: 'center',
                    alignContent: 'center',
                    height: 60
                } },
                React.createElement(TouchableOpacity, { style: { paddingLeft: 12 }, onPress: () => {
                        setAllSelected(!allSelected);
                        let selectedAllList = selectedList;
                        console.warn("ALL SELECTED VALUE", allSelected);
                        if (allSelected) {
                            const isinKeys = filterData.map((item) => item.isin);
                            const filteredsArray = selectedAllList.filter((value) => !isinKeys.includes(value));
                            setSelectedList(filteredsArray);
                            return;
                        }
                        filterData.map((item) => {
                            selectedAllList.push(item.isin);
                        });
                        setSelectedList(selectedAllList);
                    } },
                    React.createElement(Icon, { name: allSelected
                            ? IconTokens.CheckedSquare
                            : IconTokens.NotCheckedSquare, size: IconSizeTokens.XXL })),
                React.createElement(TouchableOpacity, { style: styles.itemContainer, onPress: () => {
                    } },
                    React.createElement(Text, { style: [styles.itemText, { width: 200 }], ellipsizeMode: 'tail', numberOfLines: 1 }, 'Select All'))),
            React.createElement(View, { style: {
                    backgroundColor: '#E4E7EC',
                    height: 1,
                } })));
    };
    const applyFilter = () => {
        let filteredData = [];
        if (selectedList?.length === 0) {
            setFlatListData(eligiblePressed ? mData.eligibleAssetData.MUTUAL_FUND : mData.nonEligibleAssetData.MUTUAL_FUND);
            return;
        }
        console.warn('FINAL FILTERED LIST $$$$$$$$$$$$$$$$$$$', selectedList);
        if (eligiblePressed) {
            mData.eligibleAssetData.MUTUAL_FUND.map((item) => {
                selectedList.includes(item.isin)
                    ? filteredData.push(item)
                    : null;
            });
        }
        else {
            mData.nonEligibleAssetData.MUTUAL_FUND.map((item) => {
                selectedList.includes(item.isin)
                    ? filteredData.push(item)
                    : null;
            });
        }
        setFlatListData(filteredData);
    };
    const returnFilter = () => {
        return (React.createElement(View, { style: height ?
                { width: '100%', height: height ? height : '100%' } :
                { width: '100%', flex: 1 } },
            React.createElement(HeaderDefaultBase, { title: 'Filters', isBackButton: true, onPress: () => {
                    onChangeText(false);
                    setShowFilter(false);
                } }),
            React.createElement(View, { style: height ? {
                    flexDirection: 'row',
                    width: '100%',
                    borderTopWidth: 1,
                    borderColor: '#E4E7EC',
                    height: height ? height - 56 : '100%'
                } : {
                    flexDirection: 'row',
                    width: '100%',
                    borderTopWidth: 1,
                    borderColor: '#E4E7EC',
                } },
                React.createElement(FlatList, { style: {
                        width: 150,
                        backgroundColor: '#F9FAFB',
                    }, ItemSeparatorComponent: () => (React.createElement(View, { style: {
                            backgroundColor: '#F1F3F5',
                            height: 1,
                        } })), data: eligiblePressed
                        ? filters
                        : nonEligibleFilters, renderItem: ({ item }) => (React.createElement(View, null,
                        React.createElement(TouchableOpacity, { style: {
                                justifyContent: 'center',
                                alignItems: 'flex-start',
                                padding: 20,
                            }, onPress: () => {
                                if (eligiblePressed) {
                                    setFilterData(mData.eligibleAssetData?.MUTUAL_FUND.filter((items) => items.fundType === item));
                                }
                                else {
                                    setFilterData(mData.nonEligibleAssetData?.MUTUAL_FUND.filter((items) => items.blockedReason === item));
                                }
                                setFilterName(item);
                            } }, React.createElement(Typography, { label: item, color: filterName === item
                                ? ColorTokens.Grey_Night
                                : ColorTokens.Grey_Charcoal, fontSize: FontSizeTokens.MD, fontFamily: FontFamilyTokens.Inter })))) }),
                React.createElement(View, { style: {
                        width: 1,
                        height: '100%',
                        backgroundColor: '#E4E7EC',
                    } }),
                React.createElement(ScrollView, { nestedScrollEnabled: true, style: height ? { height: height - 56, paddingBottom: 40 } : { height: 550 } },
                    filterHeader(),
                    filterData.map((item) => {
                        return (React.createElement(View, null,
                            React.createElement(ChecklistItem, { item: item, onPress: handleItemPress }),
                            React.createElement(View, { style: { backgroundColor: '#E4E7EC', height: 1 } })));
                    }))),
            React.createElement(View, { style: {
                    height: 56,
                    position: "absolute",
                    bottom: 0,
                    flexDirection: 'row',
                    backgroundColor: 'white',
                    width: '100%',
                    alignItems: 'center',
                    justifyContent: Dimensions.get('window').width < 576
                        ? 'center'
                        : 'flex-end',
                    borderWidth: 1,
                    borderColor: '#ddd',
                    borderBottomWidth: 0,
                    shadowColor: '#000000',
                    shadowOffset: { width: 0, height: 2 },
                    shadowOpacity: 0.9,
                    shadowRadius: 3,
                    elevation: 5,
                } },
                React.createElement(TouchableOpacity, { onPress: () => {
                        setAllSelected(false);
                        setSelectedList([]);
                        setFilterData(dataa.filter((item) => item.assetSubType === filterName));
                    }, style: {
                        marginRight: 18,
                        borderWidth: 1,
                        borderColor: '#1434CB',
                        backgroundColor: 'white',
                        width: 131,
                        height: 32,
                        justifyContent: 'center',
                        alignItems: 'center',
                        borderRadius: 50,
                    } },
                    React.createElement(Typography, { label: 'Reset filter', color: ColorTokens.Primary_100 })),
                React.createElement(TouchableOpacity, { onPress: () => {
                        applyFilter();
                        onChangeText(false);
                        setShowFilter(false);
                    }, style: {
                        marginRight: 30,
                        backgroundColor: '#1434CB',
                        width: 131,
                        height: 32,
                        justifyContent: 'center',
                        alignItems: 'center',
                        borderRadius: 50,
                    } },
                    React.createElement(Typography, { label: 'Apply', color: ColorTokens.White })))));
    };
    return showFilter ? (returnFilter()) : (React.createElement(View, null,
        React.createElement(View, { style: {
                flexDirection: 'row',
                justifyContent: 'space-between',
                marginTop: showPledgedFundsText ? 16 : 0,
                marginLeft: 16,
                marginRight: 16,
                marginBottom: 16
            } },
            showPledgedFundsText ? React.createElement(View, { style: { flexDirection: 'row' } },
                React.createElement(Typography, { label: "Pledged funds", fontWeight: '600', fontSize: FontSizeTokens.MD, fontFamily: FontFamilyTokens.Poppins, lineHeight: 24, color: ColorTokens.Grey_Night }),
                React.createElement(View, { style: { marginTop: 2 } },
                    React.createElement(Typography, { label: ' (' + flatlistData?.length + ')', color: ColorTokens.Black, fontFamily: FontFamilyTokens.Inter, fontWeight: '600', fontSize: FontSizeTokens.SM, lineHeight: 20 }))) : React.createElement(React.Fragment, null),
            showBar && !hideFilter ? (React.createElement(View, { style: { flexDirection: 'row', marginTop: 2 }, nativeID: 'txt_assetDetails_applyFilter' },
                React.createElement(TouchableOpacity, { onPress: () => {
                        onFitlerSet();
                    } },
                    React.createElement(Typography, { label: 'Filter ', fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, color: ColorTokens.Grey_Night, fontWeight: '500' })),
                React.createElement(TouchableOpacity, { onPress: () => {
                        onFitlerSet();
                    } },
                    React.createElement(Img, { style: {
                            width: 20,
                            height: 20,
                            marginLeft: 5,
                        }, source: {
                            uri: 'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/filter.png',
                        }, borderRadius: 8 })))) : (React.createElement(React.Fragment, null))),
        React.createElement(ScrollView, { style: showFlex ? { flex: 1, paddingHorizontal: 16 } : {
                height: isFromForeclosure ? height - 250 : Platform.OS === 'ios' ? height - 365 : height - 325,
                paddingHorizontal: 16,
                paddingBottom: (Platform.OS === 'ios' && isFromForeclosure) ? 120 : isFromForeclosure ? 16 : Platform.OS !== 'ios' ? 50 : 120,
            } },
            React.createElement(View, { style: {
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    marginTop: 6,
                } },
                React.createElement(Typography, { label: 'Mutual fund', fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.XS, color: ColorTokens.Grey_Smoke, fontWeight: '500', lineHeight: 18 }),
                React.createElement(Typography, { label: 'Credit limit', fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.XS, color: ColorTokens.Grey_Smoke, fontWeight: '500', lineHeight: 18 })),
            React.createElement(View, { style: {
                    backgroundColor: '#E4E7EC',
                    height: 1,
                    marginTop: 12,
                    width: '100%'
                } }),
            flatlistData?.length > 0 ? (React.createElement(FlatList, { data: flatlistData, renderItem: renderItem, ItemSeparatorComponent: () => (React.createElement(View, { style: {
                        backgroundColor: '#E4E7EC',
                        height: 1,
                    } })) })) : (React.createElement(View, { style: {
                    justifyContent: 'center',
                    alignItems: 'center',
                    marginTop: 40,
                } },
                React.createElement(Img, { style: { width: 140, height: 140 }, source: {
                        uri: 'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/no_investment_1.png',
                    }, borderRadius: 8 }),
                React.createElement(View, { style: { marginTop: 12 } },
                    React.createElement(Typography, { label: 'No results found' }))))),
        React.createElement(Modal, { animationType: 'slide', transparent: true, visible: showFilter, style: { position: 'absolute', bottom: 0 } },
            React.createElement(View, { style: styles.modalContainer },
                React.createElement(TouchableOpacity, { onPress: () => {
                    } })))));
};
const styles = StyleSheet.create({
    input: {
        height: 48,
        width: '100%',
        borderColor: '#98A2B3',
        borderWidth: 1,
        borderRadius: 4,
        padding: 10,
        marginTop: 10,
        color: 'black',
    },
    container: {
        justifyContent: 'center',
        alignItems: 'center',
    },
    button: {
        width: 200,
        height: 50,
        backgroundColor: 'blue',
        borderRadius: 10,
        justifyContent: 'center',
        alignItems: 'center',
    },
    modalContainer: {
        position: 'absolute',
        bottom: 0,
        width: 504,
        height: 600 * 0.5,
        backgroundColor: 'white',
        borderTopLeftRadius: 20,
        borderTopRightRadius: 20,
        padding: 20,
        justifyContent: 'flex-end',
    },
    itemContainer: {
        flexDirection: 'column',
        alignItems: 'center',
        paddingTop: 2,
        maxWidth: Dimensions.get('window').width < 576
            ? '85%'
            : '90%',
        marginLeft: 8,
    },
    itemText: {
        fontSize: 16,
        marginLeft: 3,
    },
    checkedItemText: {
        textDecorationLine: 'line-through',
    },
});
export default AssetDetails;
